import React from "react";
import localeText from "../../../../locale";

const OrderDetailsLockedCard = () => (
  <div className="card border-1 border-300">
    <div className="text-center">
      <i className="pi pi-lock text-8xl text-400 my-4" />
      <h2 className="my-6">{localeText("planNotAllowed")}</h2>
    </div>
  </div>
);

export default OrderDetailsLockedCard;

